import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [hoveredItem, setHoveredItem] = useState(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const menuItems = [
    { name: 'Home', link: '/' },
    { name: 'About Us', link: '/aboutus' },
    { name: 'Services', link: '/service' },
    { name: 'Careers', link: '/coursesinfo' },
    { name: 'Portfolio', link: '/project' },
    { name: 'Contact', link: '/contact' },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: isMobile ? '20px' : '20px 50px',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '90px', // FIXED HEIGHT ADDED
    zIndex: 100,
    boxSizing: 'border-box',
    backgroundColor: 'rgba(15, 23, 42, 0.8)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
  };

  const logoContainerStyle = { 
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    padding: '5px',
  };

  const logoImageStyle = {
    height: '48px',
    width: '48px',
    borderRadius: '50%',
    marginRight: '8px',
  };

  const hamburgerStyle = {
    display: isMobile ? 'block' : 'none',
    color: 'white',
    cursor: 'pointer',
    zIndex: 150,
  };

  const navMenuStyle = {
    display: isMobile ? 'none' : 'flex',
    listStyle: 'none',
    alignItems: 'center',
    transition: 'transform 0.3s ease-in-out',
  };

  const mobileNavMenuStyle = {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    right: 0,
    width: '75%',
    maxWidth: '300px',
    height: '100vh',
    backgroundColor: '#0f172a',
    paddingTop: '100px',
    paddingLeft: '20px',
    boxShadow: '-2px 0 10px rgba(0, 0, 0, 0.3)',
    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.5s ease-in-out',
    zIndex: 50,
  };

  const mobileOverlayStyle = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(15, 23, 42, 0.9)',
    zIndex: 40,
    transition: 'opacity 0.3s ease',
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
  };

  const linkStyle = {
    color: '#cbd5e1',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: 500,
    transition: 'color 0.3s ease, border-bottom 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '30px',
    paddingBottom: '5px',
  };

  const contactButtonStyle = {
    backgroundColor: '#d4b68f',
    color: '#1e293b',
    padding: '10px 20px',
    borderRadius: '5px',
    textDecoration: 'none',
    fontWeight: 600,
    transition: 'background-color 0.3s ease, transform 0.3s ease',
    marginLeft: '30px',
  };

  return (
    <header style={headerStyle}>
      <a href="/" style={logoContainerStyle}>
        <div style={{ position: 'relative', width: '58px', height: '58px', marginRight: '8px' }}>
          <img
            src="logo512.png"
            alt="Company Logo"
            style={{ ...logoImageStyle, position: 'absolute', top: '5px', left: '5px' }}
          />
          <svg width="250" height="58" style={{ position: 'absolute', top: 0, left: 0 }}>
            <circle
              cx="29"
              cy="29"
              r="28"
              fill="none"
              stroke="white"
              strokeWidth="2"
              style={{
                strokeDasharray: '176',
                strokeDashoffset: '176',
                animation: 'drawCircle 1s ease-in-out forwards',
              }}
            />
          </svg>
        </div>
        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontFamily: 'serif' }}>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <span style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 400, color: '#ff8c00' }}>GIRRAJ</span>
            <span style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 700, color: '#ffffff', marginLeft: '10px' }}>TECHNOLOGY</span>
          </div>
          <svg width="100%" height="3" style={{ position: 'absolute', bottom: 0, left: 0 }}>
            <line
              x1="0"
              y1="1.5"
              x2="100%"
              y2="1.5"
              stroke="#ff8c00"
              strokeWidth="2"
              style={{
                strokeDasharray: '1000',
                strokeDashoffset: '1000',
                animation: 'drawLine 1s ease-in-out 1s forwards',
              }}
            />
          </svg>
        </div>
      </a>

      <div style={hamburgerStyle} onClick={toggleMenu}>
        <svg
          style={{ height: '32px', width: '32px', transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {isOpen ? <path d="M18 6L6 18M6 6L18 18" /> : (
            <>
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </>
          )}
        </svg>
      </div>

      <nav style={navMenuStyle}>
        {menuItems.map((item) => (
          <a
            key={item.name}
            href={item.link}
            style={{
              ...linkStyle,
              color: hoveredItem === item.name ? '#ff8c00' : '#cbd5e1',
              borderBottom: hoveredItem === item.name ? '2px solid #ff8c00' : 'none',
            }}
            onMouseEnter={() => setHoveredItem(item.name)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {item.name}
          </a>
        ))}
        <a
          href="#"
          style={contactButtonStyle}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f59e0b'; e.currentTarget.style.transform = 'scale(1.05)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#d4b68f'; e.currentTarget.style.transform = 'scale(1)'; }}
        >
          Get Started
        </a>
      </nav>

      <div style={mobileOverlayStyle} onClick={toggleMenu}></div>

      <nav style={mobileNavMenuStyle}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {menuItems.map((item) => (
            <li key={item.name} style={{ width: '100%', textAlign: 'center', margin: '16px 0' }}>
              <a
                href={item.link}
                style={{
                  color: hoveredItem === item.name ? '#ff8c00' : 'white',
                  textDecoration: 'none',
                  fontSize: '18px',
                  fontWeight: 500,
                  padding: '12px 0',
                  display: 'block',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'color 0.3s ease, border-bottom 0.3s ease',
                }}
                onMouseEnter={() => setHoveredItem(item.name)}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={toggleMenu}
              >
                {item.name}
              </a>
            </li>
          ))}
          <li style={{ width: '100%', textAlign: 'center', marginTop: '24px' }}>
            <a
              href="#"
              style={{ backgroundColor: '#d4b68f', color: '#1e293b', padding: '12px 24px', borderRadius: '5px', textDecoration: 'none', fontWeight: 600, display: 'block', transition: 'background-color 0.3s ease, transform 0.3s ease' }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f59e0b'; e.currentTarget.style.transform = 'scale(1.05)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#d4b68f'; e.currentTarget.style.transform = 'scale(1)'; }}
              onClick={toggleMenu}
            >
              Get Started
            </a>
          </li>
        </ul>
      </nav>

      <style>{`
        @keyframes drawCircle { from { stroke-dashoffset: 176; } to { stroke-dashoffset: 0; } }
        @keyframes drawLine { from { stroke-dashoffset: 1000; } to { stroke-dashoffset: 0; } }
      `}</style>
    </header>
  );
};

export default Header;